let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dtqns")).then(() => parcelRequire('e2T7h'));